// src/components/Propuestas/PdfPropuesta.js

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { logoBiolab } from '../../helpers/imagen/Imagen';



export const generarPDFPropuesta = (propuesta, plantilla) => {

  console.log('Propuesta para pdf: ', propuesta);

  const doc = new jsPDF({ unit: 'mm', format: 'A4' });
  const PAGE_W = 210;
  const PAGE_H = 297;
  const MARGIN = 13;
  const CONTENT_W = PAGE_W - MARGIN * 2;
  const HEADER_H = 38;
  const FOOTER_H = 10;
  const TEAL = [34, 171, 180];
  const TEAL_LIGHT = [230, 248, 249];
  const BLACK = [30, 30, 30];
  const WHITE = [255, 255, 255];
  const GRAY_LINE = [200, 200, 200];
  const GRAY_TEXT = [100, 100, 100];

  // CARGAR PLANTILLA CON await obtenerPlantillaUnica();


  // Header table with logo, company data, SIG box
  const boxW = 62;
  const midW = CONTENT_W - 40 - boxW;
  autoTable(doc, {
    startY: MARGIN,
    margin: { left: MARGIN, right: MARGIN },
    theme: 'plain',
    tableWidth: CONTENT_W,
    styles: { cellPadding: 0, lineWidth: 0, fontSize: 7, textColor: BLACK },
    columnStyles: {
      0: { cellWidth: 40 },
      1: { cellWidth: midW },
      2: { cellWidth: boxW },
    },
    body: [[
      { content: '', styles: { minCellHeight: 28 } },
      { content: '', styles: { minCellHeight: 28 } },
      { content: '', styles: { minCellHeight: 28 } },
    ]],
    didDrawCell: (data) => {
      const cx = data.cell.x;
      const cy = data.cell.y;
      const cw = data.cell.width;
      const ch = data.cell.height;
      // Logo
      if (data.column.index === 0 && logoBiolab) {
        try {
          // PNG base64, fixed size for browser disminuir altura a 28mm y ajustar ancho proporcionalmente
          const logoHeight = 20;
          const logoWidth = (cw - 8) * (logoHeight / (ch - 8));
          doc.addImage(logoBiolab, 'PNG', cx + 4, cy + 3, logoWidth, logoHeight);
        } catch {}
      }
      // Company data
      if (data.column.index === 1) {
        const tx = cx + 3;
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8);
        doc.setTextColor(...BLACK);
        doc.text('BIOLAB LABORATORIO METROLÓGICO S.A.S.', tx, cy + 6);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7);
        doc.text('NIT 900.419.208-1', tx, cy + 11);
        doc.text('CALLE 9 #16-09', tx, cy + 15);
        doc.text('Tel: 3215873582', tx, cy + 19);
        doc.text('Cereté - Colombia', tx, cy + 23);
      }
      // SIG box
      if (data.column.index === 2) {
        const rh = ch / 4;
        // Franja 1
        doc.setFillColor(...TEAL);
        doc.rect(cx, cy, cw, rh, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(7);
        doc.setTextColor(...WHITE);
        doc.text('SIG – GESTIÓN COMERCIAL', cx + cw / 2, cy + rh * 0.68, { align: 'center' });
        // Franja 2
        doc.setFillColor(...WHITE);
        doc.setDrawColor(...TEAL);
        doc.setLineWidth(0.3);
        doc.rect(cx, cy + rh, cw, rh, 'FD');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(7);
        doc.setTextColor(...TEAL);
        doc.text(`${propuesta.snashopPlantilla?.titulo?.toUpperCase() || 'PROPUESTA COMERCIAL'}`, cx + cw / 2, cy + rh * 1.68, { align: 'center' });
        // Franja 3
        const half = cw / 2;
        doc.setFillColor(...WHITE);
        doc.setTextColor(...BLACK);
        doc.rect(cx, cy + rh * 2, half, rh, 'FD');
        doc.rect(cx + half, cy + rh * 2, half, rh, 'FD');
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(6);
        doc.text(`CÓDIGO: ${propuesta.snashopPlantilla?.codigo || 'N/A'}`, cx + 2, cy + rh * 2.68);
        doc.text(`VERSIÓN: ${propuesta.snashopPlantilla?.version || '01'}`, cx + half + 2, cy + rh * 2.68);
        // Franja 4
        doc.setFillColor(...TEAL);
        doc.rect(cx, cy + rh * 3, cw, rh, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8);
        doc.setTextColor(...WHITE);
        //EN NEGRITA EL CONSECUTIVO DE LA PROPUESTA SI EXISTE, SINO 0000
        doc.text(`No. ${propuesta.consecutivo ?? '0000'}-${propuesta.numero_version ?? '0000'}`, cx + cw / 2, cy + rh * 3.68, { align: 'center', fontStyle: 'bold', font: 'helvetica'});
      }
    },

      didDrawPage: (data) => {
        const page = doc.internal.getCurrentPageInfo().pageNumber;
        if (page > 1) {
          encabezadoSimple(doc, propuesta, MARGIN, PAGE_W, moment.utc(propuesta.fecha_propuesta || propuesta.fecha || new Date()).format('YYYY-MM-DD'));
        }
      },
  });

  // Línea divisoria
  const lineY = doc.lastAutoTable.finalY;
  doc.setDrawColor(...TEAL);
  doc.setLineWidth(0.5);
  doc.line(MARGIN, lineY, PAGE_W - MARGIN, lineY);

  // Datos del cliente
  // Nombres de cliente largos se solapaban con el NIT porque jsPDF.text no hace
  // wrap por defecto. Definimos anchos máximos por columna y envolvemos a 2
  // líneas; si aún no cabe, truncamos la última con elipsis.
  const cliente = propuesta.cliente_id || {};
  const clientY = lineY + 6;
  const col1Width = 85; // ancho máx. del Cliente antes de llegar al Nit (MARGIN + 90)
  const col2Width = 45; // ancho máx. del Nit antes de llegar a Fecha (MARGIN + 140)
  const fields = [
    { label: 'Cliente:', value: cliente.nombre || cliente.razon_social || propuesta.cliente_nombre || 'N/A', x: MARGIN,        maxWidth: col1Width },
    { label: 'Nit:',     value: cliente.nit    || propuesta.cliente_nit || 'N/A',                             x: MARGIN + 90,  maxWidth: col2Width },
    { label: 'Fecha:',   value: moment.utc(propuesta.fecha_propuesta || propuesta.fecha || new Date()).format('YYYY-MM-DD'), x: MARGIN + 140 },
  ];
  const limitarTextoLineas = (text, anchoMax, maxLineas = 2) => {
    const lineas = doc.splitTextToSize(String(text ?? ''), anchoMax);
    if (lineas.length <= maxLineas) return lineas;
    const recortadas = lineas.slice(0, maxLineas);
    let ultima = recortadas[recortadas.length - 1];
    while (ultima.length > 1 && doc.getTextWidth(ultima + '…') > anchoMax) {
      ultima = ultima.slice(0, -1);
    }
    recortadas[recortadas.length - 1] = ultima.trim() + '…';
    return recortadas;
  };
  fields.forEach(({ label, value, x, maxWidth }) => {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(...BLACK);
    doc.text(label, x, clientY);
    doc.setFont('helvetica', 'normal');
    const labelW = doc.getTextWidth(label) + 2;
    const valueX = x + labelW;
    if (maxWidth) {
      const valueMaxWidth = Math.max(10, maxWidth - labelW);
      doc.text(limitarTextoLineas(value, valueMaxWidth, 2), valueX, clientY);
    } else {
      doc.text(String(value ?? ''), valueX, clientY);
    }
  });


  // Funcion para un encabezado simple a partir de la hoja 2
  function encabezadoSimple(doc, propuesta, MARGIN, PAGE_W, fecha) {
    // Línea horizontal
    doc.setDrawColor(34, 171, 180);
    doc.setLineWidth(0.5);
    doc.line(MARGIN, 15, PAGE_W - MARGIN, 15);
    // Izquierda: Propuesta comercial No: xxxx
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(30, 30, 30);
    doc.text(`Propuesta comercial No: ${propuesta.consecutivo ?? '0000'}`, MARGIN, 12);
    // Centro: Código y versión de la plantilla
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(30, 30, 30);
    doc.text(`${propuesta.snashopPlantilla?.codigo || ''} - V. ${propuesta.snashopPlantilla?.version || '01'}`, PAGE_W / 2, 12, { align: 'center' });
    // Derecha: Fecha
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.text(fecha, PAGE_W - MARGIN, 12, { align: 'right' });
}

// Funcion para justificar texto, se le pasa el doc, el texto, x, y, ancho maximo y el interlineado
function drawJustifiedText(doc, text, x, y, width, lineHeight = 4.2) {
  const lines = doc.splitTextToSize(text, width);
  lines.forEach((line, idx) => {
    const words = line.trim().split(/\s+/);
    if (words.length === 1 || idx === lines.length - 1) {
      // Última línea o línea de una sola palabra: alineación normal
      doc.text(line, x, y);
    } else {
      // Justificar: solo suma espacio entre palabras, no después de la última
      const lineW = words.reduce((acc, w) => acc + doc.getTextWidth(w), 0);
      const spaceCount = words.length - 1;
      const spaceW = (width - lineW) / spaceCount;
      let currX = x;
      words.forEach((word, i) => {
        doc.text(word, currX, y);
        if (i < words.length - 1) {
          currX += doc.getTextWidth(word) + spaceW;
        }
      });
    }
    y += lineHeight;
  });
  return y;
}

  // Intro
  const introY = clientY + 8;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(...BLACK);
  const intro = `${propuesta.snashopPlantilla?.mensaje_inicial || 'Para BIOLAB LABORATORIO METROLÓGICO S.A.S., es muy grato presentarle y colocar a su total disponibilidad nuestros servicios de calibración y calificación de ítems biomédicos e industriales.'}`;
  const introLines = doc.splitTextToSize(intro, CONTENT_W);
  doc.text(introLines, MARGIN, introY);
  const tableStartY = introY + introLines.length * 4 + 3;

  // Tabla de ítems
  const items = propuesta.items || [];
  autoTable(doc, {
    startY: tableStartY,
    margin: { left: MARGIN, right: MARGIN, top: MARGIN + HEADER_H, bottom: FOOTER_H + 4 },
    theme: 'grid',
    headStyles: {
      fillColor: TEAL, textColor: WHITE, fontStyle: 'bold', fontSize: 7, halign: 'center', valign: 'middle', cellPadding: 2, font: 'helvetica',
    },
    bodyStyles: {
      fontSize: 7, textColor: BLACK, valign: 'top', cellPadding: 1.8, lineColor: GRAY_LINE, lineWidth: 0.15, font: 'helvetica',
    },
    alternateRowStyles: { fillColor: TEAL_LIGHT },
    columnStyles: {
      0: { halign: 'center', cellWidth: 8 },
      1: { halign: 'center', cellWidth: 14 },
      2: { halign: 'left', cellWidth: 34 },
      3: { halign: 'left', cellWidth: 'auto' },
      4: { halign: 'center', cellWidth: 13 },
      5: { halign: 'right', cellWidth: 22 },
      6: { halign: 'center', cellWidth: 14 },
      7: { halign: 'right', cellWidth: 22 },
    },
    head: [[
      { content: '#' },
      { content: 'Código' },
      { content: 'Nombre producto' },
      { content: 'Descripción' },
      { content: 'Cant.' },
      { content: 'Vr. Unitario' },
      { content: 'Impto.\nCargo' },
      { content: 'Vr. Total' },
    ]],
    body: items.map((item, idx) => [
      idx + 1,
      item.codigo || '',
      item.nombre || '',
      item.descripcion || '',
      { content: (item.cantidad ?? 1).toFixed(2), styles: { halign: 'center' } },
      { content: (item.valor_unitario ?? 0).toLocaleString('es-CO', { minimumFractionDigits: 2 }), styles: { halign: 'right' } },
      { content: `${item.porcentaje_iva ?? 19} %`, styles: { halign: 'center' } },
      { content: (item.total ?? 0).toLocaleString('es-CO', { minimumFractionDigits: 2 }), styles: { halign: 'right' } },
    ]),

      didDrawPage: (data) => {
        const page = doc.internal.getCurrentPageInfo().pageNumber;
        if (page > 1) {
          encabezadoSimple(doc, propuesta, MARGIN, PAGE_W, moment.utc(propuesta.fecha_propuesta || propuesta.fecha || new Date()).format('YYYY-MM-DD'));
        }
      },
  });

  // Totales Y DESCUENTOS SI EXISTEN
  const subtotal = items.reduce((s, i) => s + ((i.valor_unitario ?? 0) * (i.cantidad ?? 1)), 0);
  const totalIVA = items.reduce((s, i) => {
    const base = (i.valor_unitario ?? 0) * (i.cantidad ?? 1);
    const baseConDescuento = base * (1 - (i.taxDescuento ?? 0) / 100);
    const rate = (i.porcentaje_iva ?? 19) / 100;
    return s + baseConDescuento * rate;
  }, 0);
  const descuentoTotal = items.reduce((s, i) => s + ((i.valor_unitario ?? 0) * (i.cantidad ?? 1)) * ((i.taxDescuento ?? 0) / 100), 0);
  const totalPagar = subtotal + totalIVA - descuentoTotal;
  const totalsW = 80;
  const totalsX = PAGE_W - MARGIN - totalsW;
  const totalsY = doc.lastAutoTable.finalY + 3;

  autoTable(doc, {
    startY: totalsY,
    margin: { left: totalsX, right: MARGIN, top:20 },
    theme: 'plain',
    styles: { font: 'helvetica', fontSize: 8, cellPadding: 1.8, lineColor: GRAY_LINE, lineWidth: 0.15 },
    columnStyles: {
      0: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      1: { cellWidth: 35, halign: 'right' },
    },
    body: [
      // Total Bruto solo se muestra si hay descuento si no solo se muestra Subtotal con el valor total sin descuento
      ...(descuentoTotal > 0 ? [['Total Bruto', { content: subtotal.toLocaleString('es-CO', { minimumFractionDigits: 2 }), styles: { halign: 'right' } }]] : []),
      //['Total Bruto', { content: subtotal.toLocaleString('es-CO', { minimumFractionDigits: 2 }), styles: { halign: 'right' } }],
      //colocar fila en amarillo si hay descuento aplicado
      ...(descuentoTotal > 0 ? [['Descuento', { content: '-'+ descuentoTotal.toLocaleString('es-CO', { minimumFractionDigits: 2 }), styles: { halign: 'right', fillColor: [255, 255, 153] } }]] : []), // fondo amarillo claro, valor en negativo
      ['Subtotal', { content: (subtotal - descuentoTotal).toLocaleString('es-CO', { minimumFractionDigits: 2 }), styles: { halign: 'right' } }],
      ['IVA 19%', { content: totalIVA.toLocaleString('es-CO', { minimumFractionDigits: 2 }), styles: { halign: 'right' } }],
      [
        { content: 'Total a Pagar', styles: { font: 'helvetica', fontStyle: 'bold', fillColor: TEAL, textColor: WHITE, halign: 'left' } },
        { content: totalPagar.toLocaleString('es-CO', { minimumFractionDigits: 2 }), styles: { font: 'helvetica', fontStyle: 'bold', fillColor: TEAL, textColor: WHITE, halign: 'right' } },
      ],
    ],

      didDrawPage: (data) => {
        const page = doc.internal.getCurrentPageInfo().pageNumber;
        if (page > 1) {
          encabezadoSimple(doc, propuesta, MARGIN, PAGE_W, moment.utc(propuesta.fecha_propuesta || propuesta.fecha || new Date()).format('YYYY-MM-DD'));
              // Si la tabla inicia en una nueva página, mueve el cursor hacia abajo
        if (data.cursor && data.cursor.y < 20) {
          data.cursor.y = 20; // o el valor que uses para el contenido tras encabezado simple
        }
        }
      },
  });

  // Condiciones comerciales y observaciones
  let y = doc.lastAutoTable.finalY + 8;
  const secciones = [
    { titulo: 'CONDICIONES COMERCIALES', contenido: propuesta.condiciones_pago || '50% de anticipo y 50% al finalizar labor contratada.' },
    { titulo: 'TÉRMINOS Y CONDICIONES', contenido: propuesta.observaciones || '' },
  ];
  secciones.forEach(({ titulo, contenido }) => {
    if (!contenido) return;

    if (y + 10 > PAGE_H - FOOTER_H - 8) {
      doc.addPage();
      encabezadoSimple(doc, propuesta, MARGIN, PAGE_W, moment.utc(propuesta.fecha_propuesta || propuesta.fecha || new Date()).format('YYYY-MM-DD'));
      y = 20; //MARGIN + HEADER_H + 2;
    }
    doc.setFillColor(...WHITE);
    doc.rect(MARGIN, y, CONTENT_W, 7, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.setTextColor(...BLACK);
    doc.text(titulo, MARGIN + 1, y + 2.8);
    y += 7;
    const parrafos = contenido.split('\n').filter(Boolean);
    parrafos.forEach((parrafo) => {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7.5);
      doc.setTextColor(...BLACK);
      const lines = doc.splitTextToSize(parrafo.trim(), CONTENT_W);
      if (y + lines.length * 3.8 + 2 > PAGE_H - FOOTER_H - 8) {
        doc.addPage();
        encabezadoSimple(doc, propuesta, MARGIN, PAGE_W, moment.utc(propuesta.fecha_propuesta || propuesta.fecha || new Date()).format('YYYY-MM-DD'));
        y = 20; //MARGIN + HEADER_H + 2;
        // ¡Vuelve a fijar el font y tamaño tras el salto!
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7.5);
        doc.setTextColor(...BLACK);
      }

      /*doc.text(lines, MARGIN, y);
      y += lines.length * 3.8 + 2;*/
      y = drawJustifiedText(doc, parrafo.trim(), MARGIN, y, CONTENT_W, 3.8);
      y += 2;
    });
    y += 3;
  });

  // Pie de página
const totalPages = doc.internal.getNumberOfPages();
for (let i = 1; i <= totalPages; i++) {
  doc.setPage(i);
  doc.setFontSize(7);
  doc.setTextColor(...GRAY_TEXT);
  doc.setFont('helvetica', 'normal');
  // Texto a la izquierda
  doc.text('Elaborado en Tinvaz.com', MARGIN, PAGE_H - 5, { align: 'left' });
  // Texto en centro Biolab Laboratorio Metrológico SAS 
  doc.text('Biolab Laboratorio Metrológico S.A.S.', PAGE_W / 2, PAGE_H - 5, { align: 'center' });
  // Número de página a la derecha
  doc.text(`${i}/${totalPages}`, PAGE_W - MARGIN, PAGE_H - 5, { align: 'right' });
  doc.setDrawColor(...GRAY_LINE);
  doc.setLineWidth(0.2);
  doc.line(MARGIN, PAGE_H - 9, PAGE_W - MARGIN, PAGE_H - 9);
}

  // Guardar PDF
  doc.save(`Propuesta_${propuesta.consecutivo ?? '0000'}.pdf`);
};